import { Component } from '@angular/core';

@Component({
  selector: 'wun-users-icon',
  standalone: true,
  imports: [],
  templateUrl: './users-icon.component.svg',
  styleUrl: './users-icon.component.scss'
})
export class UsersIconComponent {

}
